import React from 'react';
export function PrivacyPage() {
  return <div className="min-h-screen bg-[#faf8f6] py-12 md:py-20" data-id="element-305">
      <div className="max-w-4xl mx-auto px-6" data-id="element-306">
        <h1 className="text-4xl md:text-5xl font-serif text-[#2d2d2d] mb-8" data-id="element-307">
          Política de Privacidad
        </h1>

        <div className="prose prose-lg max-w-none text-[#5a5a5a] space-y-6" data-id="element-308">
          <p className="text-sm text-[#8b6f6f]" data-id="element-309">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <section data-id="element-310">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-311">
              1. Información que Recopilamos
            </h2>
            <p data-id="element-312">
              Recopilamos información que usted nos proporciona directamente
              cuando:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-313">
              <li data-id="element-314">Realiza una compra en nuestro sitio web</li>
              <li data-id="element-315">Se suscribe a nuestro boletín informativo</li>
              <li data-id="element-316">Se comunica con nosotros</li>
            </ul>
            <p className="mt-4" data-id="element-317">
              Esta información puede incluir: nombre, dirección de correo
              electrónico, información de pago (procesada de forma segura por
              Hotmart).
            </p>
          </section>

          <section data-id="element-318">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-319">
              2. Cómo Utilizamos su Información
            </h2>
            <p data-id="element-320">Utilizamos la información recopilada para:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-321">
              <li data-id="element-322">Procesar y entregar su compra</li>
              <li data-id="element-323">Enviarle confirmaciones de pedido y actualizaciones</li>
              <li data-id="element-324">Responder a sus consultas y solicitudes de soporte</li>
              <li data-id="element-325">
                Enviarle información promocional (solo si ha dado su
                consentimiento)
              </li>
              <li data-id="element-326">Mejorar nuestros productos y servicios</li>
              <li data-id="element-327">Cumplir con obligaciones legales</li>
            </ul>
          </section>

          <section data-id="element-328">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-329">
              3. Compartir Información
            </h2>
            <p data-id="element-330">
              No vendemos, alquilamos ni compartimos su información personal con
              terceros, excepto:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-331">
              <li data-id="element-332">
                Con proveedores de servicios que nos ayudan a operar nuestro
                negocio (como Hotmart para procesamiento de pagos)
              </li>
              <li data-id="element-333">
                Cuando sea requerido por ley o para proteger nuestros derechos
              </li>
              <li data-id="element-334">Con su consentimiento explícito</li>
            </ul>
          </section>

          <section data-id="element-335">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-336">
              4. Cookies y Tecnologías Similares
            </h2>
            <p data-id="element-337">
              Utilizamos cookies y tecnologías similares para mejorar su
              experiencia en nuestro sitio web. Las cookies nos ayudan a:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-338">
              <li data-id="element-339">Recordar sus preferencias</li>
              <li data-id="element-340">Entender cómo utiliza nuestro sitio</li>
              <li data-id="element-341">Mejorar el rendimiento del sitio</li>
              <li data-id="element-342">Proporcionar contenido personalizado</li>
            </ul>
            <p className="mt-4" data-id="element-343">
              Puede configurar su navegador para rechazar cookies, aunque esto
              puede afectar la funcionalidad del sitio.
            </p>
          </section>

          <section data-id="element-344">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-345">
              5. Seguridad de Datos
            </h2>
            <p data-id="element-346">
              Implementamos medidas de seguridad técnicas y organizativas para
              proteger su información personal contra acceso no autorizado,
              pérdida o alteración. Sin embargo, ningún método de transmisión
              por Internet es 100% seguro.
            </p>
          </section>

          <section data-id="element-347">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-348">
              6. Sus Derechos
            </h2>
            <p data-id="element-349">Usted tiene derecho a:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-350">
              <li data-id="element-351">Acceder a su información personal</li>
              <li data-id="element-352">Corregir información inexacta</li>
              <li data-id="element-353">Solicitar la eliminación de sus datos</li>
              <li data-id="element-354">Oponerse al procesamiento de sus datos</li>
              <li data-id="element-355">Retirar su consentimiento en cualquier momento</li>
              <li data-id="element-356">
                Presentar una queja ante la autoridad de protección de datos
              </li>
            </ul>
          </section>

          <section data-id="element-357">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-358">
              7. Retención de Datos
            </h2>
            <p data-id="element-359">
              Conservamos su información personal durante el tiempo necesario
              para cumplir con los fines descritos en esta política, a menos que
              la ley requiera o permita un período de retención más largo.
            </p>
          </section>

          <section data-id="element-360">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-361">
              8. Enlaces a Terceros
            </h2>
            <p data-id="element-362">
              Nuestro sitio web puede contener enlaces a sitios de terceros. No
              somos responsables de las prácticas de privacidad de estos sitios.
              Le recomendamos leer sus políticas de privacidad.
            </p>
          </section>

          <section data-id="element-363">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-364">
              9. Cambios a esta Política
            </h2>
            <p data-id="element-365">
              Podemos actualizar esta Política de Privacidad periódicamente. Le
              notificaremos sobre cambios significativos publicando la nueva
              política en esta página y actualizando la fecha de "última
              actualización".
            </p>
          </section>

          <section data-id="element-366">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-367">
              10. Contacto
            </h2>
            <p data-id="element-368">
              Si tiene preguntas sobre esta Política de Privacidad o desea
              ejercer sus derechos, puede contactarnos a través de nuestro
              correo electrónico de soporte.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-[#d4a5a5]/30" data-id="element-369">
          <a href="/" className="text-[#9d4b6b] hover:text-[#8b6f6f] transition-colors font-medium" data-id="element-370">
            ← Volver a la página principal
          </a>
        </div>
      </div>
    </div>;
}